import React, { useState, useRef, useContext, useEffect } from 'react';
import { useRouter } from 'next/router';
import { S as Swiper, N as Navigation, A as A11y, a as SwiperSlide } from './a11y-f6LwtRzd.js';
import { CoreContext } from './context/index.js';
import './utils/logToSlack.js';
import './animations--PMkOS0j.js';
import 'cookies-next';
import { S as SM_WIDTH } from './breakpoints-X1SKRYyW.js';
import './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import './payment-YC9H491Y.js';
import './index-zNO-4REJ.js';
import 'notistack';
import 'next-i18next';
import { logImgLoadErrorToRelic } from './utils/logToRelic.js';
import useWindowSize from './hooks/useWindowSize.js';
import 'lodash/get';
import './product-_pRduMz7.js';
import './helpers-kA_hdoOI.js';
import 'lodash';

const CarouselComponent = ({ items = [], thumbnailImage = '', currentIndex = 0, isLightbox = false, title = '', preview = [''], setShowImageIndexModal, }) => {
    const [currentImageIndex, setCurrentImageIndex] = useState(currentIndex);
    const [swiperInstance, setSwiperInstance] = useState(null);
    const carouselRef = useRef(null);
    const { asPath } = useRouter();
    const { data } = useContext(CoreContext);
    const { imageHeight, imageWidth, imageWidthThumbnail, headingInProductImage = false, } = data.siteConfig.product;
    const windowSize = useWindowSize();
    const isSmallScreen = Boolean(windowSize.width) && windowSize.width <= SM_WIDTH;
    const onChange = (index) => {
        setCurrentImageIndex(index);
    };
    const openEnlargeImageLightbox = () => {
        if (isLightbox || isSmallScreen)
            return;
        setShowImageIndexModal(currentImageIndex);
    };
    const onSwiperInit = (swiper) => {
        setSwiperInstance(swiper);
        swiper.slideTo(currentIndex, 0);
    };
    const getImageFileName = (url) => url.split('/').pop();
    const goNext = () => {
        if (swiperInstance) {
            swiperInstance.slideNext();
        }
    };
    const goPrev = () => {
        if (swiperInstance) {
            swiperInstance.slidePrev();
        }
    };
    useEffect(() => {
        if (!preview)
            return;
        const slideImages = [...carouselRef.current.querySelectorAll('img')].map(img => getImageFileName(img.src));
        const previewImage = preview.find(previewItem => slideImages.includes(getImageFileName(previewItem)));
        if (!previewImage)
            return;
        swiperInstance.slideTo(slideImages.indexOf(getImageFileName(previewImage)), 0);
    }, [preview]);
    useEffect(() => {
        setCurrentImageIndex(currentIndex);
        if (swiperInstance) {
            swiperInstance.slideTo(currentIndex, 0);
        }
    }, [asPath]);
    return (React.createElement("div", { ref: carouselRef, className: "base-image-carousel", "aria-roledescription": "carousel", role: "group" },
        items.length > 1 && (React.createElement("button", { type: "button", className: `slider-btn slider-btn-prev ${currentImageIndex === 0 && 'hide'}`, "aria-label": "Button prev", onClick: goPrev },
            React.createElement("span", { className: "icon-left-arrow" }))),
        React.createElement(Swiper
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        , { 
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            slidesPerView: 1, modules: [Navigation, A11y], 
            // eslint-disable-next-line prettier/prettier
            onSlideChange: swiper => onChange(swiper.activeIndex), 
            // eslint-disable-next-line prettier/prettier
            onSwiper: swiper => onSwiperInit(swiper), a11y: { itemRoleDescriptionMessage: 'slide' } },
            items.map((item, index) => (React.createElement(SwiperSlide
            // eslint-disable-next-line react/no-array-index-key
            , { 
                // eslint-disable-next-line react/no-array-index-key
                key: index, onClick: openEnlargeImageLightbox, tabIndex: 0 },
                React.createElement("picture", null,
                    index === 0 && (React.createElement("source", { srcSet: thumbnailImage, media: `(max-width: ${imageWidthThumbnail}px)` })),
                    React.createElement("img", { src: item.url, className: "slider-image", 
                        // aria-label={item.label}
                        alt: `${title} ${index + 1}`, width: imageWidth, height: imageHeight, onError: () => logImgLoadErrorToRelic(asPath, item.url), loading: index === 0 ? 'eager' : 'lazy' }))))),
            !isLightbox && headingInProductImage && React.createElement("h1", null, title)),
        items.length > 1 && (React.createElement("button", { type: "button", className: `slider-btn slider-btn-next ${currentImageIndex >= items.length - 1 && 'hide'}`, "aria-label": "Button next", onClick: goNext },
            React.createElement("span", { className: "icon-right-arrow" })))));
};

export { CarouselComponent as C };
//# sourceMappingURL=Carousel-6OJTdlUL.js.map
